export default function WorkItemDisplay({ workSample, className = '' }) {
  return workSample.service === 'youtube' ? (
    <iframe
      className={`flex flex-1 overflow-hidden rounded ${className}`}
      src={`https://www.youtube.com/embed/${workSample.serviceData}`}
      allowFullScreen={true}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    />
  ) : (
    <iframe
      className={`flex flex-1 overflow-hidden rounded ${className}`}
      src={`https://player.twitch.tv/?video=${workSample.serviceData}&parent=www.gridfinder.com`}
      allowFullScreen={true}
    />
  )
}
